import React, { useState, useCallback } from 'react';
import GalleryFilter from '../componets/GalleryFilter';
import { galleryItems, galleryCategories } from '../componets/galleryData';
import SliderContent from '../componets/SliderContent';
import Arrows from '../componets/Arrows';
import Dots from '../componets/Dots';
import './Gallery.css';

const Gallery = () => {
	const [activeCategory, setActiveCategory] = useState('Apartments');
	const [sliderOpen, setSliderOpen] = useState(false);
	const [sliderActiveIndex, setSliderActiveIndex] = useState(0);
	const [sliderItems, setSliderItems] = useState([]);

	const handleCategoryChange = useCallback((category) => {
		setActiveCategory(category);
	}, []);

	const filteredItems = galleryItems.filter(
		(item) => item.category === activeCategory,
	);

	const handleImageClick = (item, index) => {
		// Set slider items to the clicked project's images
		setSliderItems(item.images || []);
		setSliderActiveIndex(index);
		setSliderOpen(true);
	};

	const handleCloseSlider = () => {
		setSliderOpen(false);
	};

	const handlePrevSlide = () => {
		setSliderActiveIndex(
			sliderActiveIndex === 0 ? sliderItems.length - 1 : sliderActiveIndex - 1,
		);
	};

	const handleNextSlide = () => {
		setSliderActiveIndex(
			sliderActiveIndex === sliderItems.length - 1 ? 0 : sliderActiveIndex + 1,
		);
	};

	return (
		<div className="gallery-page">
			<div className="gallery-header"  id="about-banner">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<h1>
								Our Work 
							</h1>
						</div>
					</div>
				</div>
			</div>

			<GalleryFilter
				categories={galleryCategories}
				activeCategory={activeCategory}
				onCategoryChange={handleCategoryChange}
			/>

			<div className="gallery-container">
				<div className="container">
					<div className="gallery-grid">
						{filteredItems.map((item, index) => (
							<div
								key={item.id}
								className="gallery-item"
								onClick={() => handleImageClick(item, 0)}
								style={{ cursor: 'pointer' }}
							>
								<div className="gallery-item-wrapper">
									<img
										src={item.image}
										alt={item.title}
										className="gallery-image"
									/>
									<div className="gallery-overlay">
										<div className="gallery-info">
											<h3>{item.title}</h3>
											<p>{item.description}</p>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			{/* Image Slider Modal */}
			{sliderOpen && (
				<div className="slider-modal-overlay" onClick={handleCloseSlider}>
					<div
						className="slider-modal-content"
						onClick={(e) => e.stopPropagation()}
					>
						<button
							className="slider-close-btn"
							onClick={handleCloseSlider}
							aria-label="Close slider"
						>
							✕
						</button>

						<div className="gallery-slider-container">
							<SliderContent
								activeIndex={sliderActiveIndex}
								sliderImage={sliderItems}
							/>
							<Arrows prevSlide={handlePrevSlide} nextSlide={handleNextSlide} />
							<Dots
								activeIndex={sliderActiveIndex}
								sliderImage={sliderItems}
								onclick={(index) => setSliderActiveIndex(index)}
							/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default Gallery;
